import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/icons/pen.png'


const _hoisted_1 = { class: "h-full w-full" }
const _hoisted_2 = { class: "__setup-target-smart __section shadow-sm bg-white overflow-hidden" }
const _hoisted_3 = { class: "__section__header font-semibold text-neutral-600 p-6 border-b" }
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-600" }, "Luca AI"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "text-neutral-500 font-normal leading-5 text-sm mt-2",
    style: {"max-width":"700px"}
  }, " Ở chế độ bật, cơ sở can thiệp có thể sử dụng Luca AI ")
], -1)
const _hoisted_6 = {
  key: 0,
  class: "__section__content"
}
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50 gap-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group__label uppercase text-neutral-400 text-xs font-semibold" }, " Giới hạn lượt chat với trợ lý luca AI "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 font-normal leading-5 text-sm mt-2" }, " Ở chế độ bật, mỗi tài khoản chỉ được sử dụng tối đa số tin nhắn giới hạn mỗi tháng. Ở chế độ tắt, số tin nhắn không bị giới hạn. ")
], -1)
const _hoisted_10 = {
  key: 1,
  class: "__section__header font-semibold text-neutral-600 p-6 border-b"
}
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "input-group flex-nowrap flex items-center justify-between" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "uppercase text-neutral-400 text-xs font-semibold w-1/2 ml-6" }, " số tin nhắn giới hạn mỗi tháng cho 1 tài khoản ", -1)
const _hoisted_14 = {
  key: 0,
  class: "w-1/2"
}
const _hoisted_15 = {
  key: 1,
  class: "flex items-center justify-between w-1/2"
}
const _hoisted_16 = { class: "text-neutral-800 font-normal" }
const _hoisted_17 = {
  key: 0,
  class: "flex justify-end mt-6"
}
const _hoisted_18 = { class: "__setup-target-smart __section shadow-sm bg-white overflow-hidden mt-10" }
const _hoisted_19 = { class: "__section__header font-semibold text-neutral-600 p-6 border-b" }
const _hoisted_20 = { class: "flex items-center justify-between" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-600" }, "Thực đơn"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "text-neutral-500 font-normal leading-5 text-sm mt-2",
    style: {"max-width":"700px"}
  }, " Ở chế độ bật, cơ sở can thiệp có thể sử dụng tính năng thực đơn ")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5 h-5",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "__section__content" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold" }, " Sử dụng tính năng thực đơn ", -1)
const _hoisted_28 = {
  key: 0,
  class: "py-4 px-6 bg-white"
}
const _hoisted_29 = { class: "text-neutral-400 w-1/2 text-xs uppercase" }
const _hoisted_30 = { class: "text-neutral-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditMenu = _resolveComponent("EditMenu")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.sideOverShow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.sideOverShow ? 'side-over--active' : '')
        }, [
          _createElementVNode("div", {
            class: "fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sideOverShow = false))
          }),
          _createVNode(_component_EditMenu, {
            onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sideOverShow = false)),
            menu: _ctx.menu,
            onUpdate: _ctx.updateMenu
          }, null, 8, ["menu", "onUpdate"])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_SwitchButton, {
              value: _ctx.enable_ai_button,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.enable_ai_button) = $event))
            }, null, 8, ["value"])
          ])
        ]),
        (_ctx.enable_ai_button)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_SwitchButton, {
                    value: _ctx.enable_limit_ai_chat,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.enable_limit_ai_chat) = $event))
                  }, null, 8, ["value"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.enable_ai_button && _ctx.enable_limit_ai_chat)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  (_ctx.editLimitAiChatCount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.limit_ai_chat_count) = $event)),
                          class: "text-neutral-700 text-sm"
                        }, null, 512), [
                          [_vModelText, _ctx.limit_ai_chat_count]
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.limit_ai_chat_count || 0) + " tin nhắn (" + _toDisplayString(_ctx.limit_ai_chat_count * 2) + " Luca Xu) ", 1),
                        _createElementVNode("img", {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editLimitAiChatCount = true)),
                          src: _imports_0,
                          alt: "",
                          class: "w-5 h-5 cursor-pointer"
                        })
                      ]))
                ]),
                (_ctx.editLimitAiChatCount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("button", {
                        class: "button-p text-center whitespace-nowrap w-fit",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.changeLimitAiChatCount && _ctx.changeLimitAiChatCount(...args)))
                      }, " Lưu chỉnh sửa ")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            (_ctx.enabled_menu)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "cursor-pointer",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sideOverShow = true))
                }, _hoisted_23))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_SwitchButton, {
                value: _ctx.enabled_menu,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.enabled_menu) = $event))
              }, null, 8, ["value"])
            ])
          ])
        ]),
        (_ctx.enabled_menu)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex items-center py-4 px-6",
                  key: item.id
                }, [
                  _createElementVNode("div", _hoisted_29, " Bữa " + _toDisplayString(index === 0 ? 'đầu tiên' : 'thứ') + " " + _toDisplayString(index !== 0 ? index + 1 : '') + " trong ngày ", 1),
                  _createElementVNode("div", _hoisted_30, _toDisplayString(item.name), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}